import styled from 'styled-components'
import FlairText from './FlairText'

const Lead = styled(FlairText)`
  font-size: 0.75rem;
`

export default Lead
